import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClock, faPlus } from '@fortawesome/pro-light-svg-icons'

import { Box, Text } from '@domain-group/suit-theme'

import styles from './styles.module.scss'

interface EditionEmptyProps {
  isBeforeBookingDeadline: boolean,
  onClick: VoidFunction,
}

const EditionEmpty = (props: EditionEmptyProps) => {
  const { isBeforeBookingDeadline, onClick } = props

  const color = isBeforeBookingDeadline ? 'blue' : 'red'

  return (
    <Box
      alignItems="center"
      border="1px dashed"
      borderColor="lineColor"
      borderRadius="5px"
      className={styles.root}
      flexDirection="column"
      justifyContent="center"
      onClick={onClick}
      padding="xxlarge"
      width="60%"
    >
      <Text color={color} fontSize="xxlarge">
        <FontAwesomeIcon icon={isBeforeBookingDeadline ? faPlus : faClock} />
      </Text>
      {!isBeforeBookingDeadline && (
        <Text color={color} fontSize="xxlarge">Booking Deadline Passed</Text>
      )}
      <Text color={color}>Add First Page</Text>
    </Box>
  )
}

export default EditionEmpty
